import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Question } from "@phosphor-icons/react";

export function WhatDoesThisMean({ text, testId = "explainer" }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={`${testId}-button`}
          className="inline-flex items-center gap-1 text-igc-goldText/70 hover:text-igc-goldText text-[10px] uppercase tracking-wide ml-2 align-middle transition-colors"
        >
          <Question size={12} weight="bold" />
          What does this mean?
        </button>
      </PopoverTrigger>
      <PopoverContent
        data-testid={`${testId}-content`}
        className="bg-igc-surface border-igc-gold/20 text-igc-cream text-sm leading-relaxed w-72"
      >
        {text}
      </PopoverContent>
    </Popover>
  );
}
